module.exports = __webpack_public_path__ + "img/_silk.ad81e611.jpg";